/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGCard(props) {
  return (
    <svg width={52} height={66} viewBox="0 0 52 66" {...props}>
      <g>
        <rect
          id="Combined-Shape"
          fill="#E6F5FB"
          x={1}
          y={1}
          width={50}
          height={64}
          rx={2}
        />
        <path
          d="M1 3c0-1.104.889-2 1.991-2h46.018c1.1 0 1.991.89 1.991 2v34h-50v-34z"
          id="Combined-Shape"
          fill="#CBECF9"
        />
        <rect
          id="Combined-Shape"
          fill="#97D9F2"
          x={5}
          y={49}
          width={42}
          height={10}
          rx={2}
        />
        <path
          d="M22.317 31h-14.934c-.555 0-.659-.291-.239-.642l8.889-7.45c.423-.355 1.113-.352 1.533 0l4.618 3.87 8.581-7.593c.413-.366 1.083-.366 1.496 0l12.604 11.153c.413.366.305.662-.256.662h-22.292zm-5.817-12c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z"
          id="Combined-Shape"
          fill="#E6F5FB"
        />
        <path
          d="M2 3.003v59.993c0 .551.448 1.003.991 1.003h46.018c.547 0 .991-.447.991-1.003v-59.993c0-.551-.448-1.003-.991-1.003h-46.018c-.547 0-.991.447-.991 1.003zm-2 0c0-1.658 1.336-3.003 2.991-3.003h46.018c1.651 0 2.991 1.352 2.991 3.003v59.993c0 1.658-1.336 3.003-2.991 3.003h-46.018c-1.651 0-2.991-1.352-2.991-3.003v-59.993zm50-.004c0-.556-.442-1-.991-1h-46.018c-.548 0-.991.446-.991 1v33h48v-33zm-50 0c0-1.656 1.336-3 2.991-3h46.018c1.654 0 2.991 1.34 2.991 3v35h-52v-35zm6 48v6.001c0 .557.444 1 .997 1h38.005c.549 0 .997-.448.997-1v-6.001c0-.557-.444-1-.997-1h-38.005c-.549 0-.997.448-.997 1zm-2 0c0-1.656 1.344-3 2.997-3h38.005c1.658 0 2.997 1.337 2.997 3v6.001c0 1.656-1.344 3-2.997 3h-38.005c-1.658 0-2.997-1.337-2.997-3v-6.001z"
          fill="#00A1DE"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGCard.js